// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2PuRw","colBig":"styles_colBig__3TWSb","colSmall":"styles_colSmall__3Gmqz","shopifyNameWrapper":"styles_shopifyNameWrapper__3aMRx"};